module.exports = __webpack_public_path__ + "img/user-menu-cards.5054b62f.svg";